export default (props, vars) => props?.['name'] === 'twitter';
